<div class="profile-menu">
  <div class="options">
    <div (click)="onUserProfileClick()" class="item">
      <app-icon-settings class="icon icon-fill"></app-icon-settings>
      <span>Profile Settings</span>
    </div>
    <div (click)="onSignOutClick()" class="item danger">
      <app-icon-log-in class="icon icon-stroke"></app-icon-log-in>
      <span>Sign Out</span>
    </div>
    @if (isMobile) {
      <div (click)="onOpenNotificationsClick()" class="item">
        <app-icon-bell-outline class="icon icon-fill"></app-icon-bell-outline>
        <span>Notifications</span>
      </div>
    }
  </div>

</div>
